// extracted by mini-css-extract-plugin
module.exports = {"CollectionLinks":"CollectionLinks_CollectionLinks__Ry1mu"};